export interface TopColum {
  color: {
    base: string;
    icon: string;
    font: string;
    comment: string;
  };
  icon: string;
  comment: string;
}

class ExpiredColum implements TopColum {
  color = {
    base: 'red lighten-5',
    icon: 'red darken-2',
    font: '',
    comment: 'red',
  };
  icon = 'priority_high';
  comment = '至急受講';
}

class NoDeadlineColum implements TopColum {
  color = {
    base: 'amber lighten-5',
    icon: 'amber darken-2',
    font: '',
    comment: 'amber',
  };
  icon = 'warning';
  comment = '期限未設定';
}

class DoingColum implements TopColum {
  color = {
    base: 'white',
    icon: 'grey lighten-2',
    font: '',
    comment: 'grey',
  };
  icon = 'check_circle_outline';
  comment = '実施中';
}

class DoneColum implements TopColum {
  color = {
    base: 'white',
    icon: 'green darken-2',
    font: 'grey--text',
    comment: 'grey',
  };
  icon = 'check_circle';
  comment = '完了';
}

export type ColumType = 'expired' | 'no-deadline' | 'doing' | 'done';
export const TopColum = (type: ColumType): TopColum | null => {
  switch (type) {
    case 'expired':
      return new ExpiredColum();
    case 'no-deadline':
      return new NoDeadlineColum();
    case 'done':
      return new DoneColum();
    case 'doing':
      return new DoingColum();
    default:
      return null;
  }
};

export type TraineeType = 'doing' | 'done' | 'removed';
export interface Trainee {
  color: Array<string>;
  fcolor: string;
  comment: string;
  icon: string;
}

class DoneTrainee implements Trainee {
  color = ['green', 'darken-2'];
  fcolor = 'grey';
  icon = 'check_circle';
  constructor(public comment: string) {
    this.comment = `完了:${comment}`;
  }
}

class DoingTrainee implements Trainee {
  color = ['grey', 'lighten-1'];
  fcolor = 'black';
  icon = 'error_outline';
  constructor(public comment: string) {
    this.comment = '未完了';
  }
}

class RemovedTrainee implements Trainee {
  color = ['grey', 'lighten-1'];
  fcolor = 'black';
  icon = 'error_outline';
  constructor(public comment: string) {
    this.comment = '未完了';
  }
}

export const Trainee = (type: TraineeType, comment: string): Trainee | null => {
  switch (type) {
    case 'doing':
      return new DoingTrainee(comment);
    case 'done':
      return new DoneTrainee(comment);
    case 'removed':
      return new RemovedTrainee(comment);
    default:
      return null;
  }
};

export type TrainingCategory = {
  key: string;
  name: string;
  order: number;
};

export const TrainingCategoryDefault = 'all';

export type FavoriteCategory = {
  branchOfficeID: string;
  trainingIDs: Array<string>;
};
